// tslint:disable: no-input-rename

import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { PopoverBody } from './popover-body.type';
import { PopoverService } from './popover.service';
import { PopoverRef } from './popover-ref';

@Directive({ selector: '[sukaPopover]' })
export class Popover {
  private popoverRef: PopoverRef;
  private open = false;

  @Input('sukaPopover') body: PopoverBody = '';
  @Input('popoverPosition') position: 'top' | 'bottom' = 'bottom';
  @Input('popoverAlignment') alignment: 'left' | 'right' | 'center' = 'left';
  @Input('popoverSectioned') sectioned = false;

  constructor(protected popoverService: PopoverService, private elementRef: ElementRef) { }

  private show() {
    this.popoverRef = this.popoverService.open(
      {
        content: {
          body: this.body,
          sectioned: this.sectioned,
        },
        position: this.position,
        alignment: this.alignment,
      },
      this.elementRef
    );

    this.open = true;

    this.popoverRef.afterClosed().subscribe((result: any) => {
      this.open = false;
    });
  }

  @HostListener('click')
  onClick() {
    if (!this.open) {
      this.show();
    }
  }
}
